import createReducer from 'utils/createReducer';

// Constants
export const formKeys = {
    CAPTCHA_TOKEN: 'CAPTCHA_TOKEN',
    NAME: 'NAME',
    EMAIL: 'EMAIL',
    COMPANY: 'COMPANY',
    NOTE: 'NOTE',
};

export const STATUS_IDLE = 'STATUS_IDLE';
export const STATUS_SUCCESS = 'STATUS_SUCCESS';
export const STATUS_LOADING = 'STATUS_LOADING';
export const STATUS_ERROR = 'STATUS_ERROR';

const SET_VALUE = 'SET_VALUE';
const SET_ERROR = 'SET_ERROR';
const SET_SUBMISSION_STATUS = 'SET_SUBMISSION_STATUS';

// Initial state
export const initState = {
    form: {
        [formKeys.CAPTCHA_TOKEN]: {
            value: null,
            error: null,
        },
        [formKeys.NAME]: {
            value: null,
            error: null,
        },
        [formKeys.EMAIL]: {
            value: null,
            error: null,
        },
        [formKeys.COMPANY]: {
            value: null,
            error: null,
        },
        [formKeys.NOTE]: {
            value: null,
            error: null,
        },
    },
    submissionStatus: STATUS_IDLE,
};

// Reducer
export const reducer = createReducer(initState, {
    [SET_VALUE]: (state, { payload }) => ({
        ...state,
        form: {
            ...state.form,
            [payload.key]: {
                value: payload.value,
                error: null,
            },
        },
    }),
    [SET_ERROR]: (state, { payload }) => ({
        ...state,
        form: {
            ...state.form,
            [payload.key]: {
                ...state.form[payload.key],
                error: payload.error,
            },
        },
    }),
    [SET_SUBMISSION_STATUS]: (state, { payload }) => ({
        ...state,
        submissionStatus: payload,
    }),
});

// Actions
export const setValue = (key, value) => ({
    type: SET_VALUE,
    payload: {
        key,
        value,
    },
});

export const setError = (key, error) => ({
    type: SET_ERROR,
    payload: {
        key,
        error,
    },
});

export const setSubmissionStatus = (status) => ({
    type: SET_SUBMISSION_STATUS,
    payload: status,
});

// Selectors
export const getFormValue = (state, key) => state.form[key].value;
export const getFormError = (state, key) => state.form[key].error;
export const getSubmissionStatus = (state) => state.submissionStatus;
